import { applicantDetailsKey } from '@features/applicant';
import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  errorMessage,
  deleteHireflixRoute,
  enterpriseApplicationsKey,
  interviewCountsKey,
} from '@features/applications';
import { eventsInterviewKey } from '@features/events';
import { jobPostingsKey } from '@features/jobPostings';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

type UseDeleteHireflixInterviewProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useDeleteHireflixInterview = ({
  setErrorText,
  onSuccess,
}: UseDeleteHireflixInterviewProps) => {
  const client = useQueryClient();

  const {
    mutate: deleteHireflixInterview,
    isLoading: isDeleteHireflixInterviewLoading,
  } = useMutation({
    mutationFn: (variables: { application_id: number }) =>
      axiosInstance
        .post(deleteHireflixRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(eventsInterviewKey);
        client.invalidateQueries(applicationHistoryKey);
        client.invalidateQueries(enterpriseApplicationsKey);
        client.invalidateQueries(interviewCountsKey);
        client.invalidateQueries(applicantDetailsKey);
        client.invalidateQueries(jobPostingsKey);
        onSuccess?.();
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    deleteHireflixInterview,
    isDeleteHireflixInterviewLoading,
  };
};
